<template>
	<div>
        <div class="noticeWrap">
            <div class="newsTabWrap">
                <div :class="{on:cate==4}" @click="link2Route(4)">{{ $t('temporary_announcement') }}</div>
                <div :class="{on:cate==5}" @click="link2Route(5)">{{ $t('regular_announcement') }}</div>
            </div>
            <div class="listWrap">
                <notice-item :NoticeItem="item" v-for="(item,index) in noticeList" :key="index" />
            </div>
            <div class="pageSizeWrap">
                <img :src="`${imgPath}/static/assets/img/left.png`" @click="ckpage('sub')" />
                <img :src="`${imgPath}/static/assets/img/right.png`" @click="ckpage('add')" />
            </div>
        </div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
                cate:this.$route.params.type,
                noticeList:[],
				page:1,
				allpage:1
			}
		},
		async mounted() {
			this.getNotice();
		},
		methods: {
            link2Route(id){
				this.$router.push(`/notice/list/${id}`);
            },
			async getNotice(){
				let data = await this.$util.getNoticeList({cate:this.cate, page:this.page,lang:localStorage.getItem('language') || 'zh-cn'});
				this.allpage = data.pages.allpage;
                this.noticeList = data.list;
            },
            ckpage(type){
                if(type==='sub'){
                    if(this.page !== 1){
                        this.page--;
			            this.getNotice();
                    }
                }
                if(type==='add'){
                    if(this.page < this.allpage){
                        this.page++;
                        this.getNotice();
                    }
                }
            }
		}
	}
</script>
<style lang="scss" scoped>
.noticeWrap{
    .newsTabWrap {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.4rem;
        >div {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 0.24rem;
            font-weight: 400;
            color: rgba($color: #161A1A, $alpha: 1.0);
            min-width: 1.48rem;
            padding: 0 0.1rem;
            height: 0.66rem;
            text-align: center;
            border-radius: 33px;
            &.on {
                background: #C8EDE9;
                font-weight: bold;
                color: #161A1A;
            }
        }
    }
    .listWrap{
        margin-top: 0.1rem;
    }
    .pageSizeWrap {
        width: 3.2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin:  0.3rem auto;
        >span {
            font-size: 0.4rem;
        }
        >img {
            width: 0.51rem;
            height: 0.52rem;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/notice/noticeList.vue